import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Layout,
  Form,
  Input,
  Button,
  Select,
  Card,
  Row,
  Col,
  Breadcrumb,
  Space,
  Switch,
} from "antd";

// import { convertToSlug, getBaseUrl } from '../../utils/browser'
import { useBackend } from "backend/useBackend";
import { useSelector } from "react-redux";
import { selectCMS } from "features/cms/cmsSlice";
import { DebounceSelect } from "cms/components/DebounceSelect";

const { Content } = Layout;

const endpoint = "quotes";

const Add = () => {
  const navigate = useNavigate();
  const { statuses } = useSelector(selectCMS);
  const [topics, setTopics] = useState([]);

  const { addItem, searchItems } = useBackend();

  async function getTopics(topic) {
    return searchItems("topics", "name", topic).then((items) => {
      return items.map((item) => ({
        label: item.name,
        value: item.name,
      }));
    });
  }

  async function getAuthors(name) {
    return searchItems("authors", "fullName", name).then((items) => {
      return items.map((item) => ({
        label: item.fullName,
        value: item.fullName,
      }));
    });
  }

  const onFinish = (values) => {
    const payload = {
      ...values,
      author: values?.author?.value || values?.author,
      topics: values.topics.map(topic => topic.value),
    };
    // console.log(payload)
    addItem(endpoint, payload, {
      redirectTo: endpoint,
      loader: true,
      msg: {
        loading: "Adding...",
        success: "Quote Added",
      },
    });
  };

  const onFinishFailed = (data) => console.log(data);

  return (
    <Content>
      <Breadcrumb>
        <Breadcrumb.Item>Quotes</Breadcrumb.Item>
        <Breadcrumb.Item>Add</Breadcrumb.Item>
      </Breadcrumb>
      <Row>
        <Col md={12}>
          <Card title="Add Details">
            <Form
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{
                status: "Draft",
              }}
              size={"large"}
            >
              {/* <Row gutter={24}>
                <Col md={12}>
                  <Form.Item
                    className="mb-2"
                    label="Title"
                    name="title"
                    // rules={[{ required: true, message: "Title is required" }]}
                  >
                    <Input placeholder="Title" />
                  </Form.Item>
                </Col>
                <Col md={12}>
                  <Form.Item
                    className="mb-2"
                    label="Slug"
                    name="slug"
                    // rules={[{ required: true, message: "Slug is required" }]}
                    size={"large"}
                  >
                    <Input placeholder="Slug" />
                  </Form.Item>
                </Col>
              </Row> */}
              <Form.Item
                required
                className="mb-2"
                label="Quote"
                name="content"
                rules={[{ required: true, message: "Quote is required" }]}
                size={"large"}
              >
                <Input.TextArea placeholder="Quote" rows={5} />
              </Form.Item>
              <Form.Item
                required
                className="mb-2"
                label="Author"
                name="author"
                rules={[{ required: true, message: "Author is required" }]}
                size={"large"}
              >
                <DebounceSelect
                  showSearch
                  // value={author}
                  placeholder="Select Author"
                  fetchOptions={getAuthors}
                  // onChange={(obj) => {
                  //   setAuthor(obj.value);
                  // }}
                  style={{
                    width: "100%",
                  }}
                />
              </Form.Item>
              <Form.Item
                className="mb-2"
                // required
                label="Topics"
                name="topics"
                rules={[{ required: true, message: "Topics is required" }]}
                size={"large"}
              >
                <DebounceSelect
                  mode="tags"
                  value={topics}
                  placeholder="Select Topics"
                  fetchOptions={getTopics}
                  onChange={(obj) => {
                    setTopics(obj.value);
                  }}
                  style={{
                    width: "100%",
                  }}
                />
              </Form.Item>
              <Form.Item
                className="mb-2"
                // required
                label="Status"
                name="status"
                rules={[{ required: true, message: "Status is required" }]}
                size={"large"}
              >
                <Select
                  placeholder="Select Status"
                  optionFilterProp="children"
                  // onChange={onChange}
                  // onSearch={onSearch}
                  // defaultValue={"Draft"}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={statuses}
                />
              </Form.Item>
              <Form.Item
                className="mb-2"
                label="Featured"
                name="featured"
                size={"large"}
              >
                <Switch />
              </Form.Item>
              <Form.Item>
                <Row justify="end" style={{ marginTop: "2em" }}>
                  <Col>
                    <Space size="small">
                      <Button type="primary" htmlType="submit" size="large">
                        Add
                      </Button>
                      <Button
                        type="primary"
                        ghost
                        size="large"
                        onClick={() => navigate(-1)}
                      >
                        Back
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </Content>
  );
};

export default Add;
